import { EffectCallback, useEffect, useRef } from 'react';

const useEffectOnceOnCondition = (
  callback: EffectCallback,
  conditionFn: () => boolean,
  deps: any[] = []
) => {
  const hasRunEffectRef = useRef(false);

  useEffect(() => {
    if (hasRunEffectRef.current) {
      return;
    }

    if (conditionFn()) {
      hasRunEffectRef.current = true;
      return callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps.concat(callback, conditionFn));
};

export default useEffectOnceOnCondition;
